import { reactive } from "@vue/composition-api";
import _axios from "@/axios";
import { handleFormErrors } from "@/composables/form-error";
import { useClientPortal } from "@/composables/client-portal";

export function useClientPortalBackground() {
  const { currentClientPortal } = useClientPortal();

  let clientPortalBackgroundData = reactive({
    backgroundFile: null,
    backgroundFormRef: null,
    background_fileRules: [
      (v) => !!v || "Le nom du fichier ne peut pas être vide",
      (v) => (v && v.size < 512000) || "taille max 512 Ko",
    ],
    dialogForBackground: false,
    deleteDialog: false,
    editedItem: null,
    uploadError: false,
  });

  function uploadBackground(clientId) {
    const formData = new FormData();
    if (clientPortalBackgroundData.backgroundFile instanceof Blob) {
      formData.append(
        "file",
        clientPortalBackgroundData.backgroundFile,
        "upload"
      );
    }
    formData.append("type", "background");

    return _axios
      .post(`/client-portal-upload/${clientId}`, formData, {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${clientPortalBackgroundData._boundary}`,
        },
      })
      .then((response) => {
        const clientPortal = response.data.data;
        currentClientPortal.value = clientPortal;
        clientPortalBackgroundData.uploadError = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          clientPortalBackgroundData,
          clientPortalBackgroundData.backgroundFormRef
        );
        clientPortalBackgroundData.uploadError = true;
      });
  }

  function removeBackground(clientId) {
    const formData = new FormData();
    formData.append("type", "background");

    return _axios
      .post(`/client-portal-remove/${clientId}`, formData)
      .then((response) => {
        const clientPortal = response.data.data;

        currentClientPortal.value = clientPortal;
      })
      .catch(() => {});
  }

  return {
    clientPortalBackgroundData,
    uploadBackground,
    removeBackground,
  };
}
